import React, { useEffect, useState } from "react";
import "./Benifits.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import Benifits_Component from "../Benifits_Component/Benifits_Component";
import { useParams } from "react-router-dom";

const Benifits = () => {
  const [benefitsData, setBenefitsData] = useState([]);
  const { id } = useParams();

  const data = [
    {
      id: 1,
      benefits: [
        { title: "Global & Local Reach", descn: "Expand your brand’s visibility locally and internationally." },
        { title: "Cost-Effective Marketing", descn: "Achieve higher returns on investment compared to traditional advertising." },
        { title: "Enhanced Engagement", descn: "Foster a two-way communication channel with your audience." },
        { title: "Real-Time Insights", descn: "Make data-driven decisions with in-depth analytics." },
        { title: "Brand Loyalty", descn: "Build long-lasting trust and relationships with your audience." },
      ],
    },
    {
      id: 2,
      benefits: [
        { title: "Instant Visibility", descn: "Appear at the top of search engine results pages and social media feeds." },
        { title: "Targeted Reach", descn: "Focus on users who are most likely to convert." },
        { title: "Budget Control", descn: "Flexible budgets that scale according to your goals." },
        { title: "Measurable Results", descn: "Track every click, impression, and conversion with precision." },
        { title: "Boosts Conversions", descn: "Drive traffic to landing pages designed to turn visitors into customers." },
      ],
    },
    {
      id: 3,
      benefits: [
        { title: "Enhanced User Experience", descn: "A well-designed site keeps visitors engaged and reduces bounce rates." },
        { title: "Higher Search Rankings", descn: "SEO-friendly designs improve visibility and drive organic traffic." },
        { title: "Increased Conversions", descn: "Intuitive layouts and clear CTA’s lead to more leads and sales." },
        { title: "Brand Credibility", descn: "A professional website builds trust and authority in your industry." },
        { title: "Scalability", descn: "Easily add new features, pages, or integrations as your business grows." },
      ],
    },
    {
      id: 4,
      benefits: [
        { title: "Drives Organic Traffic", descn: "High-quality, optimized content attracts more visitors to your site." },
        { title: "Builds Brand Authority", descn: "Position your business as a trusted expert in your field." },
        { title: "Engages Your Audience", descn: "Informative and engaging content keeps your audience coming back." },
        { title: "Supports SEO Efforts", descn: "Regularly updated content improves search rankings." },
        { title: "Increases Conversions", descn: "Well-crafted content guides potential customers through the sales funnel." },
        { title: "Cost-Effective Marketing", descn: "Generate long-term results without relying solely on paid ads." },
      ],
    },
    {
      id: 5,
      benefits: [
        { title: "Builds Trust", descn: "A strong online reputation fosters confidence in your brand." },
        { title: "Increases Revenue", descn: "Positive reviews and a good image attract more customers." },
        { title: "Mitigates Damage", descn: "Quickly addresses negative feedback or PR issues to reduce long-term impact." },
        { title: "Improves Customer Retention", descn: "Engaging with feedback shows customers you value their opinions." },
        { title: "Enhances Competitive Edge", descn: "Stand out in the market with a consistently positive reputation." },
      ],
    },
    {
      id: 6,
      benefits: [
        { title: "Increased Visibility", descn: "Rank higher in search results and attract more organic traffic." },
        { title: "Cost-Effective Marketing", descn: "Generate long-term traffic without ongoing ad spend." },
        { title: "Improved Credibility", descn: "Higher rankings signal trust and authority to users." },
        { title: "Enhanced User Experience", descn: "A well-optimized site improves navigation, speed, and usability." },
        { title: "Higher ROI", descn: "SEO drives qualified leads, increasing conversions and sales." },
        { title: "Competitive Advantage", descn: "Stay ahead of competitors by dominating search results." },
      ],
    },
    {
      id: 7,
      benefits: [
        { title: "Direct Communication", descn: "Reach your audience straight in their inbox for a personal connection." },
        { title: "High ROI", descn: "Email marketing delivers one of the highest returns on investment among digital channels." },
        { title: "Increased Conversions", descn: "Targeted campaigns drive sales by engaging users with relevant offers." },
        { title: "Cost-Effective", descn: "Scalable and affordable campaigns with measurable results." },
        { title: "Customer Retention", descn: "Regular communication builds trust and encourages repeat business." },
        { title: "Time-Saving Automation", descn: "Automatically nurture leads and keep your audience engaged without constant manual effort." },
      ],
    },
    {
      id: 8,
      benefits: [
        { title: "Authentic Promotion", descn: "Influencers create organic content that feels natural to their followers." },
        { title: "Targeted Reach", descn: "Connect with niche audiences that align with your brand." },
        { title: "Increased Trust", descn: "Influencers’ endorsements build credibility for your products or services." },
        { title: "Boosts Engagement", descn: "Interactive and relatable influencer content drives likes, shares, and comments." },
        { title: "Cost-Effective Marketing", descn: "Achieve significant ROI by leveraging existing influencer audiences." },
        { title: "Supports Brand Awareness", descn: "Amplify your brand’s presence and visibility in your industry." },
      ],
    },
    {
      id: 9,
      benefits: [
        { title: "Instant Reach", descn: "Deliver messages directly to customers’ smartphones within seconds." },
        { title: "High Engagement", descn: "WhatsApp boasts open rates of over 90%, ensuring your message gets seen." },
        { title: "Personalized Communication", descn: "Send tailored messages that resonate with your audience." },
        { title: "Multimedia Flexibility", descn: "Share images, videos, documents, or links to enhance engagement." },
        { title: "Cost-Effective Marketing", descn: "Save on traditional advertising costs with targeted messaging." },
        { title: "Boosts Conversions", descn: "Encourage quick actions, like inquiries or purchases, through clickable links." },
        { title: "Wide Accessibility", descn: "Connect with users across urban and rural markets on a platform they trust." },
      ],
    },
    {
      id: 10,
      benefits: [
        { title: "Instant Communication", descn: "Reach your audience in real-time, no matter where they are." },
        { title: "High Open Rates", descn: "Over 95% of SMS messages are opened within minutes." },
        { title: "Wide Reach", descn: "Connect with customers across demographics, including those without smartphones or internet access." },
        { title: "Personalized Messaging", descn: "Tailor messages to include names or specific offers for better engagement." },
        { title: "Affordable Marketing", descn: "Cost-effective for reaching large audiences compared to traditional methods." },
        { title: "Boost Conversions", descn: "Drive immediate actions, such as visits, bookings, or purchases, with clickable links." },
        { title: "Regulatory Compliance", descn: "Ensure adherence to SMS marketing guidelines for seamless delivery." },
      ],
    },
    {
      id: 11,
      benefits: [
        { title: "Personalized Communication (Voice Calls)", descn: "Create a human connection through spoken messages." },
        { title: "Wide Reach (Voice Calls)", descn: "Connect with a broad audience, including those less tech-savvy." },
        { title: "Interactive Features (Voice Calls)", descn: "Enable responses or actions using IVR options." },
        { title: "Cost-Effective (Voice Calls)", descn: "Automated calls reduce manual effort and operational costs." },
        { title: "Effortless Engagement (Missed Call System)", descn: "Customers just need to dial once and disconnect, making it hassle-free." },
        { title: "Lead Generation (Missed Call System)", descn: "Capture potential customer details instantly for your CRM." },
        { title: "Real-Time Responses (Missed Call System)", descn: "Automate SMS or callback follow-ups for seamless engagement." },
        { title: "Customer Insights (Missed Call System)", descn: "Analyse the data to understand and target your audience better." },
      ],
    }
    


    
  ];

  useEffect(() => {
    const filteredArray = data.filter((item) => item.id === Number(id));
    setBenefitsData(filteredArray);
  }, [id]);

  return (
    <div className="Benifits">
      <div className="container">
        <div className="title_div">
          <p className="title">Benefits</p>
        </div>
        <div className="card_holder_main_div">
          <Swiper
            className="mySwiper"
            spaceBetween={10}
            slidesPerView={6}
            modules={[Pagination]}
            pagination={{ dynamicBullets: true, clickable: true }}
            breakpoints={{
              0: { slidesPerView: 1, spaceBetween: 10 },
              425: { slidesPerView: 1.3, spaceBetween: 15 },
              768: { slidesPerView: 2, spaceBetween: 20 },
              1200: { slidesPerView: 3, spaceBetween: 25 },
            }}
          >
            {benefitsData?.[0]?.benefits?.map((item, index) => (
              <SwiperSlide key={index}>
                <Benifits_Component
                  className={index === 0 ? "first-component" : ""}
                  title={item.title}
                  description={item.descn}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Benifits;
